class LpWelcomeHero extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('.lp-welcome-hero__video');
    this.playButton = this.querySelector('button.lp-welcome-hero__play');
    this.cta = this.querySelector('.lp-welcome-hero__cta');

    this.handlePlayRequest = this.handlePlayRequest.bind(this);
    this.handleVideoPlay = this.handleVideoPlay.bind(this);
    this.handleVideoPause = this.handleVideoPause.bind(this);

    this.playButton?.addEventListener('click', this.handlePlayRequest);
    this.cta?.addEventListener('click', this.handlePlayRequest);
    this.video?.addEventListener('play', this.handleVideoPlay);
    this.video?.addEventListener('pause', this.handleVideoPause);
  }

  disconnectedCallback() {
    this.playButton?.removeEventListener('click', this.handlePlayRequest);
    this.cta?.removeEventListener('click', this.handlePlayRequest);
    this.video?.removeEventListener('play', this.handleVideoPlay);
    this.video?.removeEventListener('pause', this.handleVideoPause);
  }

  handlePlayRequest() {
    if (!this.video) return;
    this.video.scrollIntoView({ behavior: 'smooth', block: 'center' });
    this.video.play();
  }

  handleVideoPlay() {
    this.classList.add('lp-welcome-hero--playing');
  }

  handleVideoPause() {
    if (this.video?.ended) {
      this.classList.remove('lp-welcome-hero--playing');
    }
  }
}

if (!customElements.get('lp-welcome-hero')) {
  customElements.define('lp-welcome-hero', LpWelcomeHero);
}
